var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"footer-props":_vm.footerProps,"headers":_vm.headers,"items":_vm.statistics,"loading":_vm.loading},scopedSlots:_vm._u([{key:"item.totalAmount",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("currency")(item.totalAmount,'$', 0, { thousandsSeparator: '.' }))+" ")]}},{key:"item.totalBusinessFee",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("currency")(item.totalBusinessFee,'$', 0, { thousandsSeparator: '.' }))+" ")]}},{key:"item.totalProfit",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("currency")(item.totalProfit,'$', 0, { thousandsSeparator: '.' }))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }